
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { BookOpen, Camera } from "lucide-react";
import { supabase } from "@/lib/supabase";

interface Recipe {
  id: string;
  title: string;
  created_at: string;
  image_url: string | null;
  user: {
    username: string;
  };
}

interface MyRecipesCardProps {
  recipes: Recipe[];
}

export const MyRecipesCard = ({ recipes }: MyRecipesCardProps) => {
  const navigate = useNavigate();

  const handleRecipeClick = async (recipe: Recipe) => {
    const { data: normalizedUsername } = await supabase
      .rpc('normalize_username', { username: recipe.user.username });
    
    if (normalizedUsername) {
      navigate(`/${normalizedUsername}/${recipe.id}`);
    }
  };

  return (
    <Card className="p-6 space-y-4">
      <div className="flex items-center gap-2">
        <BookOpen className="w-5 h-5 text-primary" />
        <h2 className="text-xl font-semibold">My Recipes</h2>
      </div>
      <div className="space-y-3">
        {recipes.slice(0, 5).map((recipe) => (
          <div
            key={recipe.id}
            className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
            onClick={() => handleRecipeClick(recipe)}
          >
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-md overflow-hidden bg-gray-200 flex items-center justify-center">
                {recipe.image_url ? (
                  <img
                    src={recipe.image_url}
                    alt={recipe.title}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <Camera className="w-6 h-6 text-gray-400" />
                )}
              </div>
              <span className="font-medium">{recipe.title}</span>
            </div>
            <span className="text-sm text-gray-500">
              {new Date(recipe.created_at).toLocaleDateString()}
            </span>
          </div>
        ))}
        {recipes.length === 0 && (
          <p className="text-gray-500 text-center py-4">
            No recipes created yet
          </p>
        )}
      </div>
    </Card>
  );
};
